import React, { FormEvent, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import './relocationsurvey.css';
import { toast } from 'react-toastify';
import { GetSurveyDetailsbyInstanceIdAsync, GetSurveyResponseAsync, SaveServeyResponse } from '../../../services/surveyService/SurveyService';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../../firebase/AuthProvider';
import backarrowbtn  from '../../../assets/images/backarrowbtn.svg'
import { EmergencyEventDto } from '../../../interfaces/survey/SurveyDtos';

const initialRelocationSurveyData = {
    sameEvacuationLocation: "",
    newLocationType: "",
    newAddress: "",
    relationshipOfPerson: "",
    apartment: "",
    city: "",
    state: "",
    zipCode: "",
    homePhone: "",
    cellPhone: "",
    returnedToPermanentHome: "",
    returnDate: "",
    description: ""
};

const Relocationsurvey: React.FC = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { participantId, instanceId } = useParams();
    const [surveyDetails, setSurveyDetails] = useState<EmergencyEventDto>();
    const [surveyData, setSurveyData] = useState<typeof initialRelocationSurveyData>(initialRelocationSurveyData);
    const [isAlreadyFilled, setIsAlreadyFilled] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [authToken, setAuthToken] = useState<string>();

    useEffect(() => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                setAuthToken(token);
                if (instanceId) {
                    GetSurveyResponse(token, instanceId);
                    GetSurveyDetailsByInstanceId(token, instanceId);
                }
            }
        })
    }, []);


     const GetSurveyDetailsByInstanceId = ( token : string, instance_Id : string) =>{
            GetSurveyDetailsbyInstanceIdAsync(token, instance_Id).then((res)=>{
                if(res.success){
                    setSurveyDetails(res.data);
                }else{
                    toast.error(res.message);
                }
            }).catch((err)=>{
                    toast.error(err.message);
            })
        }
    

    // check and get the survey with this instance id is already field or not
    const GetSurveyResponse = (token: string, instance_Id: string) => {
        setLoading(true);
        GetSurveyResponseAsync(token, instance_Id).then((res) => {
            if (res.success) {
                const surveyData = JSON.parse(res.data.responseData);
                setSurveyData(surveyData)
                setIsAlreadyFilled(true);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    // Handlers
    const handleRadio = (key: keyof typeof initialRelocationSurveyData, value: string) => {
        setSurveyData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleInput = (key: keyof typeof initialRelocationSurveyData, value: string) => {
        setSurveyData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Validation function
    const validateSurvey = () => {
        // All top-level fields are required
        if (!surveyData.sameEvacuationLocation) return false;

        // If "Yes", subfields are required
        if (surveyData.sameEvacuationLocation === "Yes") {
            if (
                !surveyData.newLocationType ||
                !surveyData.newAddress ||
                !surveyData.relationshipOfPerson ||
                !surveyData.apartment ||
                !surveyData.city ||
                !surveyData.state ||
                !surveyData.zipCode ||
                !surveyData.homePhone ||
                !surveyData.cellPhone
            ) {
                return false;
            }
        }

        if (!surveyData.returnedToPermanentHome) return false;

        // If returnedToPermanentHome is "Yes", returnDate and description are required
        if (surveyData.returnedToPermanentHome === "Yes") {
            if (!surveyData.returnDate || !surveyData.description) {
                return false;
            }
        }



        return true;
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!validateSurvey()) {
            toast.error("Please fill all required fields.");
            return;
        }

        if (!authToken || !instanceId) return;

        setLoading(true);
        SaveServeyResponse(authToken, surveyData, instanceId).then((res) => {
            if (res.success) {
                toast.success(res.message);
                navigate(`/surveys/participant/${participantId}`)
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        }).finally(() => {
            setLoading(false);
        })
    };

    useEffect(() => {
        // If "No" for sameEvacuationLocation, flush all subfields related to new location
        if (surveyData.sameEvacuationLocation === "No") {
            setSurveyData(prev => ({
                ...prev,
                newLocationType: "",
                newAddress: "",
                relationshipOfPerson: "",
                apartment: "",
                city: "",
                state: "",
                zipCode: "",
                homePhone: "",
                cellPhone: "",
            }));
        }

        // If "No" for returnedToPermanentHome, flush returnDate and description
        if (surveyData.returnedToPermanentHome === "No") {
            setSurveyData(prev => ({
                ...prev,
                returnDate: "",
                description: "",
            }));
        }
    }, [surveyData.sameEvacuationLocation, surveyData.returnedToPermanentHome]);

    return (
        <>
            <div className="prestorm_survey_conatiner">
                <Form onSubmit={handleSubmit}>
                    <div className="common_card">
                        <div className="top border_tittle mby_16">
                            <div className="top_bar_tittle">
                                <h2><Link to={`/surveys/participant/${participantId}`}><img src={backarrowbtn} alt="" /></Link> {surveyDetails?.emergencyType}</h2>
                            </div>
                            <div>
                                <p>EmergencyDetail :  {surveyDetails?.emergencyDetail}</p>
                            </div>
                        </div>
                        <Form.Group className="step_form_grp" controlId="Q1">
                            <Form.Label>1. Are you still at the same evacuation location?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Group controlId="" className='radio_flx'>
                                    <Form.Check
                                        type="radio"
                                        id="Q1yes"
                                        name="Q1"
                                        label="Yes"
                                        className='check_with_label_two'
                                        checked={surveyData.sameEvacuationLocation === "Yes"}
                                        onChange={() => handleRadio("sameEvacuationLocation", "Yes")}
                                        disabled={isAlreadyFilled}
                                    />
                                </Form.Group>
                                <Form.Group controlId="" className='radio_flx'>
                                    <Form.Check
                                        type="radio"
                                        id="Q1no"
                                        name="Q1"
                                        label="No"
                                        className='check_with_label_two'
                                        checked={surveyData.sameEvacuationLocation === "No"}
                                        onChange={() => handleRadio("sameEvacuationLocation", "No")}
                                        disabled={isAlreadyFilled}
                                    />
                                </Form.Group>

                            </div>
                        </Form.Group>
                        {surveyData.sameEvacuationLocation === "Yes" &&
                            (
                                <Form.Group className="step_form_grp mby_t_16" controlId="Q1Location">
                                    <Form.Label>New Location Type</Form.Label>
                                    <div className="check_list_flx flex-column">
                                        <Form.Group controlId="agreementRadioButtons">
                                            <Form.Check
                                                type="radio"
                                                id="Q1LocationShelter"
                                                name="Q1Location"
                                                label="Shelter"
                                                className='check_with_label_two'
                                                checked={surveyData.newLocationType === "Shelter"}
                                                onChange={() => handleRadio("newLocationType", "Shelter")}
                                                disabled={isAlreadyFilled}
                                            />
                                        </Form.Group>
                                        <Form.Group controlId="agreementRadioButtons">
                                            <Form.Check
                                                type="radio"
                                                id="Q1LocationHotel"
                                                name="Q1Location"
                                                label="Hotel / Motel"
                                                className='check_with_label_two'
                                                checked={surveyData.newLocationType === "Hotel / Motel"}
                                                onChange={() => handleRadio("newLocationType", "Hotel / Motel")}
                                                disabled={isAlreadyFilled}
                                            />
                                        </Form.Group>
                                        <Form.Group controlId="agreementRadioButtons">
                                            <Form.Check
                                                type="radio"
                                                id="Q1LocationFriend"
                                                name="Q1Location"
                                                label="Friend or Family's Home"
                                                className='check_with_label_two'
                                                checked={surveyData.newLocationType === "Friend or Family's Home"}
                                                onChange={() => handleRadio("newLocationType", "Friend or Family's Home")}
                                                disabled={isAlreadyFilled}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className='mby_t_16'>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>New Address</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter address"
                                                        value={surveyData.newAddress}
                                                        onChange={e => handleInput("newAddress", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>Relationship of Person</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter name"
                                                        value={surveyData.relationshipOfPerson}
                                                        onChange={e => handleInput("relationshipOfPerson", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-12">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>Apartment</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Apartment"
                                                        value={surveyData.apartment}
                                                        onChange={e => handleInput("apartment", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />

                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>City</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter city"
                                                        value={surveyData.city}
                                                        onChange={e => handleInput("city", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>State</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter State"
                                                        value={surveyData.state}
                                                        onChange={e => handleInput("state", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />

                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>Zip Code</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Enter zip code"
                                                        value={surveyData.zipCode}
                                                        onChange={e => handleInput("zipCode", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>Home Phone at Relocation</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Enter address"
                                                        value={surveyData.homePhone}
                                                        onChange={e => handleInput("homePhone", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-12">
                                                <Form.Group className="custom_input_flled" controlId="">
                                                    <Form.Label>Cell Phone</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Enter number"
                                                        value={surveyData.cellPhone}
                                                        onChange={e => handleInput("cellPhone", e.target.value)}
                                                        disabled={isAlreadyFilled}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            )}

                    </div>
                    <div className="common_card">
                        <Form.Group className="step_form_grp" controlId="Q2">
                            <Form.Label>2. Have you returned to your permanent home?</Form.Label>
                            <div className="check_list_yes_no">
                                <Form.Group controlId="" className='radio_flx'>
                                    <Form.Check
                                        type="radio"
                                        id="Q2Yes"
                                        name="Q2"
                                        label="Yes"
                                        className='check_with_label_two'
                                        checked={surveyData.returnedToPermanentHome === "Yes"}
                                        onChange={() => handleRadio("returnedToPermanentHome", "Yes")}
                                        disabled={isAlreadyFilled}
                                    />
                                </Form.Group>
                                <Form.Group controlId="" className='radio_flx'>
                                    <Form.Check
                                        type="radio"
                                        id="Q2No"
                                        name="Q2"
                                        label="No"
                                        className='check_with_label_two'
                                        checked={surveyData.returnedToPermanentHome === "No"}
                                        onChange={() => handleRadio("returnedToPermanentHome", "No")}
                                        disabled={isAlreadyFilled}
                                    />
                                </Form.Group>
                            </div>
                        </Form.Group>
                        <div className='mby_t_16'>
                            {
                                surveyData.returnedToPermanentHome === "Yes" &&
                                (
                                    <>
                                        <Form.Group className="custom_input_flled" controlId="">
                                            <Form.Label>Return Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                placeholder="Select date"
                                                value={surveyData.returnDate}
                                                onChange={e => handleInput("returnDate", e.target.value)}
                                                disabled={isAlreadyFilled}
                                            />
                                        </Form.Group>
                                        <Form.Group className="custom_input_flled mb-0" controlId="">
                                            <Form.Label>Add Description</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                placeholder="Enter description"
                                                value={surveyData.description}
                                                onChange={e => handleInput("description", e.target.value)}
                                                disabled={isAlreadyFilled}
                                            />
                                        </Form.Group>
                                    </>
                                )
                            }
                            <div className='mby_t_24'>
                                <Button variant='primary' className='w-100' type="submit" disabled={isAlreadyFilled}>Submit</Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
};

export default Relocationsurvey;










//Previous code
// import React from 'react';
// import Form from 'react-bootstrap/Form';
// import { Button } from 'react-bootstrap';
// import './relocationsurvey.css';

// const Relocationsurvey: React.FC = () => {
//     return (
//         <>
//             <div className="prestorm_survey_conatiner">
//                 <div className="common_card">
//                     <div className="top border_tittle mby_16">
//                         <div className="top_bar_tittle">
//                             <h2>Relocation Follow up Survey</h2>
//                         </div>
//                     </div>
//                     <Form.Group className="step_form_grp" controlId="Q1">
//                         <Form.Label>1. Are you still at the same evacuation location?</Form.Label>
//                         <div className="check_list_yes_no">
//                             <Form.Group controlId="" className='radio_flx'>
//                                 <Form.Check
//                                     type="radio"
//                                     id="Q1yes"
//                                     name="Q1"
//                                     label="Yes"
//                                     className='check_with_label_two'
//                                 />
//                             </Form.Group>
//                             <Form.Group controlId="" className='radio_flx'>
//                                 <Form.Check
//                                     type="radio"
//                                     id="Q1no"
//                                     name="Q1"
//                                     label="No"
//                                     className='check_with_label_two'
//                                 />
//                             </Form.Group>
//                         </div>
//                     </Form.Group>
//                     <Form.Group className="step_form_grp mby_t_16" controlId="Q1Location">
//                         <Form.Label>New Location Type</Form.Label>
//                         <div className="check_list_flx flex-column">
//                             <Form.Group controlId="agreementRadioButtons">
//                                 <Form.Check
//                                     type="radio"
//                                     id="Q1Locationstrongly-agree"
//                                     name="Q1Location"
//                                     label="Shelter"
//                                     className='check_with_label_two'
//                                 />
//                             </Form.Group>
//                             <Form.Group controlId="agreementRadioButtons">
//                                 <Form.Check
//                                     type="radio"
//                                     id="Q1Locationagree"
//                                     name="Q1Location"
//                                     label="Hotel / Motel"
//                                     className='check_with_label_two'
//                                 />
//                             </Form.Group>
//                             <Form.Group controlId="agreementRadioButtons">
//                                 <Form.Check
//                                     type="radio"
//                                     id="Q1Locationneutral"
//                                     name="Q1Location"
//                                     label="Friend or Family's Home"
//                                     className='check_with_label_two'
//                                 />
//                             </Form.Group>
//                         </div>
//                         <div className='mby_t_16'>
//                             <div className="row">
//                                 <div className="col-md-6">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>New Address</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter address" />
//                                     </Form.Group>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>Relationship of Person</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter name" />
//                                     </Form.Group>
//                                 </div>
//                                 <div className="col-md-12">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>Apartment</Form.Label>
//                                         <Form.Select aria-label="Default select example">
//                                             <option>Enter Apt</option>
//                                             <option value="1">One</option>
//                                             <option value="2">Two</option>
//                                             <option value="3">Three</option>
//                                         </Form.Select>
//                                     </Form.Group>
//                                 </div> <div className="col-md-6">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>City</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter city" />
//                                     </Form.Group>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>State</Form.Label>
//                                         <Form.Select aria-label="Default select example">
//                                             <option>Select state</option>
//                                             <option value="1">One</option>
//                                             <option value="2">Two</option>
//                                             <option value="3">Three</option>
//                                         </Form.Select>
//                                     </Form.Group>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>Zip Code</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter zip code" />
//                                     </Form.Group>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>Home Phone at Relocation</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter address" />
//                                     </Form.Group>
//                                 </div>
//                                 <div className="col-md-12">
//                                     <Form.Group className="custom_input_flled" controlId="">
//                                         <Form.Label>Cell Phone</Form.Label>
//                                         <Form.Control type="text" placeholder="Enter number" />
//                                     </Form.Group>
//                                 </div>
//                             </div>
//                         </div>
//                     </Form.Group>
//                 </div>
//                 <div className="common_card">
//                     <Form.Group className="step_form_grp" controlId="Q2">
//                         <Form.Label>2. Have you returned to your permanent home?</Form.Label>
//                         <div className="check_list_yes_no">
//                             <Form.Group controlId="" className='radio_flx'>
//                                 <Form.Check
//                                     type="radio"
//                                     id="Q2Yes"
//                                     name="Q2"
//                                     label="Yes"
//                                     className='check_with_label_two'
//                                 />
//                             </Form.Group>
//                             <Form.Group controlId="" className='radio_flx'>
//                                 <Form.Check
//                                     type="radio"
//                                     id="Q2No"
//                                     name="Q2"
//                                     label="No"
//                                     className='check_with_label_two'
//                                 />
//                             </Form.Group>
//                         </div>
//                     </Form.Group>
//                     <div className='mby_t_16'>
//                         <Form.Group className="custom_input_flled" controlId="">
//                             <Form.Label>Return Date</Form.Label>
//                             <Form.Control type="date" placeholder="Select date" />
//                         </Form.Group>
//                         <Form.Group className="custom_input_flled mb-0" controlId="">
//                             <Form.Label>Add Description</Form.Label>
//                             <Form.Control as="textarea" rows={3} placeholder="Enter description" />
//                         </Form.Group>
//                         <div className='mby_t_24'>
//                             <Button variant='primary' className='w-100 '>Submit</Button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Relocationsurvey;